import React, { useState, useRef } from 'react';
import Classes from '../Routes.module.css';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { EclipseIcon } from '../../../../../../utils/Icons';

export default function PipelineMenu({
  handleopenReschedulePopup,
  allEmployees = [],
  columnId,
  appt,
  onMove,
}) {
  const [dropDown, setdropDown] = useState(false);
  const dropdownRef = useRef(null);
  const navigateTo = useNavigate();

  const targets = allEmployees.filter((c) => c.id !== columnId); // exclude current

  return (
    <div className={Classes.dropDown} ref={dropdownRef}>
      <div className={Classes.menuIcon} onClick={() => setdropDown(!dropDown)}>
        <EclipseIcon cursor='pointer' height="20px" />
      </div>

      <AnimatePresence>
        {dropDown && (
          <motion.div initial={{ opacity: 0, y: -5 }} animate={{ opacity: 1, y: 0 }} className={Classes.dropDownBody}>
            <div className={Classes.dropDownBodyInner}>

              <div className={Classes.dropDownElem}>
                <h5> Move to {'>'} </h5>
                <div className={Classes.dropDownBody2}>
                  <div className={Classes.dropDownBody2Inner}>
                    {/* Unassigned */}
                    {columnId !== "unassigned" && (
                      <div className={Classes.dropDownElem} onClick={() => { onMove?.(appt.id, columnId, "unassigned"); setdropDown(false); }}>
                        {/* <h5>Unassigned</h5> */}
                      </div>
                    )}
                    {/* Employees */}
                    {targets.map((t) => (
                      <div key={t.id} className={Classes.dropDownElem}
                        onClick={() => { onMove?.(appt.id, columnId, t.id); setdropDown(false); }}>
                        <h5>{t.name}</h5>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className={Classes.dropDownLine}></div>
              <div className={Classes.dropDownElem} onClick={() => navigateTo(`/view-appointment/details/${appt.id}`)}>
                <h5>View Appointment</h5>
              </div>
              <div className={Classes.dropDownLine}></div>
              <div className={Classes.dropDownElem} onClick={() => navigateTo(`/client-detail/details/${appt.userId}`)}>
                <h5>View Client</h5>
              </div>
              <div className={Classes.dropDownLine}></div>
              <div className={Classes.dropDownElem} onClick={() => handleopenReschedulePopup(appt)}>
                <h5>Reschedule</h5>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
